import React, { useEffect, useState } from "react";

const Confirmed = ({ values }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="relative text-center py-6">

      <div
        className={`transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        {/* Icône animée */}
        <div className="relative inline-flex items-center justify-center mb-5">
          <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping" />
          <div className="relative w-20 h-20 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center success-glow">
            <span className="text-4xl" role="img" aria-label="Félicitations">
              🎉
            </span>
          </div>
        </div>

        <h3 className="text-2xl font-bold text-foreground mb-1">
          Félicitations !
        </h3>

        {values?.pseudo && (
          <p className="text-primary font-semibold text-lg mb-2">
            Bienvenue, {values.pseudo} !
          </p>
        )}

        <p className="text-sm text-muted-foreground">
          Votre adhésion est maintenant prise en compte.
        </p>

        <div className="mt-5 flex justify-center gap-2">
          {["🎮", "🎭", "✨", "🌟", "🚀"].map((emoji, i) => (
            <span
              key={i}
              className="text-xl"
              style={{
                animation: `particle-float ${1.5 + i * 0.3}s ease-in-out infinite`,
                animationDelay: `${i * 0.25}s`,
                display: "inline-block",
              }}
            >
              {emoji}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Confirmed;
